import React from 'react';
import inboxService from 'venuescanner-js/react/components/Inbox/services/inboxService';
import Tip from 'venuescanner-js/react/components/Inbox/components/Objects/Tip';

const CtaShowToOrganiser = props => {
  const { thread } = props;

  const handleClick = () => {
    return inboxService.showToOrganiser({
      _id: thread._id,
    });
  };

  return (
    <Tip
      title={false}
      text={
        <>
          This is a Concierge managed Enquiry. Ready to hand it over to the
          Organiser?{' '}
          <span onClick={handleClick} className='cta-hot-spot'>
            Click here
          </span>
        </>
      }
    />
  );
};

export default CtaShowToOrganiser;
